import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {BrickSnake2000Symbol, SymbolArgs} from "./BrickSnake2000Symbol";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";

export class BrickSnake2000ScatterSymbol extends BrickSnake2000Symbol {

    public static scatterCount:number = 0;
    private scatterIndex:number = 0;

    public static resetScatterCount():void {
        BrickSnake2000ScatterSymbol.scatterCount = 0;
    }

    constructor(args:SymbolArgs) {
        if (!args.isSpinning && (args.reelPosition >= 0 && args.reelPosition < 5)) {
            BrickSnake2000ScatterSymbol.scatterCount++;
        }
        const scatterIndex = Math.max(1, args.isSpinning
                                              ? Math.floor(Math.random() * 5) + 1
                                              : BrickSnake2000ScatterSymbol.scatterCount);
        //args.suffix = `${scatterIndex}`;
        super(args);

        this.scatterIndex = scatterIndex;

        this.view.removeChild(this.winAnimation);
        this.winAnimation = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.SCATTER));
        this.view.addChild(this.winAnimation);
    }

    public moveToNormalLayer(object: PIXI.DisplayObject = this) {
        this.reelsView.layers.maskedScatters.addChild(object);
        (<BrickSnake2000Symbol[]>this.reelsView.layers.maskedScatters.children).sort((a, b) => {
            return ((4 - a.reelID) * a.reelPosition) - ((4 - b.reelID) * b.reelPosition);
        })
    }

    public getActivateAnimation(index:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0,   index == -1
                                                                       ? "S_Win"
                                                                       : index == 0
                                                                       ? "S_Snake_A"
                                                                       : "S_Snake_B"))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }

    public getLandAnimation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, `S_Land`))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }

    public startAnticipation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.mainSprite.alpha = 0;
                this.winAnimation.alpha = 1;
                //this.moveToWinLayer();
                this.winAnimation.state.setAnimation(0, `S_Anticipation`, true);
            })
    }

    public stopAnticipation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.mainSprite.alpha = 1;
                this.winAnimation.alpha = 0;
                //this.moveToNormalLayer();
                this.winAnimation.state.setEmptyAnimation(0, 0.1);
            })
    }
}

